import { useAccount } from "@qw/auth";
import type { ChatHeaderProps } from "@qw/chat";
import { Spinner } from "@qw/ui";
import { useParams } from "react-router";
import { useInboxQueryStates } from "@/providers/inbox-query-states-provider";
import { useConversation } from "@/providers/use-conversation";

import { BookChatPanel } from "./book-chat-panel";
import { ChatSessionMessages } from "./chat-session-messages";

export interface ChatSessionProps {
  header?: ChatHeaderProps;
  toolFilterStorageKey: string;
}

export const ChatSession = ({ header, toolFilterStorageKey }: ChatSessionProps) => {
  const { user } = useAccount();
  const { conversationId } = useInboxQueryStates();
  const { insuredId } = useParams();
  const { loading: conversationLoading } = useConversation();

  if (conversationId && conversationLoading) {
    return (
      <div className="px-4 py-5">
        <Spinner />
      </div>
    );
  }

  if (!conversationId && !insuredId) {
    return <BookChatPanel key={user.id} brokerId={user.id} header={header} />;
  }

  // Key to force a fresh chat tree when switching between conversation and insured contexts.
  const sessionKey = conversationId || insuredId;

  return <ChatSessionMessages key={sessionKey} header={header} toolFilterStorageKey={toolFilterStorageKey} />;
};
